import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import {Button, Modal, Row, Form } from 'react-bootstrap';

import { toast } from 'react-toastify'


import Dialog from '../../services/Dialogs'

const ModalSucursalesDirectorComercial = ( params : any ) => {


  const dialog = new Dialog();



  const { show, handleClose, director_comercial } = params


  const [ sucursales, setSucursales] = useState<any>([])

  const cargarSucursales = async() => {

    try{
      let res = await RequestService.getEndPoint('sucursales')
      // console.log(res.data)
      let s = res.data.map((sucursal:any)=>{ return { checked : false, sucursal : sucursal.nombre_sucursal, uuid : sucursal.uuid } })
      for(let sucursal of s){
        for(let sucursal_registrada of director_comercial.sucursales){
          if(sucursal.uuid === sucursal_registrada.uuid) sucursal.checked = true
        }
      }
      setSucursales(s)
    }
    catch(e){
      toast.error('Tuvimos problemas al cargar la lista de Gerentes')
    }

  }


  React.useEffect(() => {
    cargarSucursales()
  }, []);




const [ envio_server, setSeEnvio ] = useState<boolean>(false)

const enviarFormulario = async (event:any) =>{
  // console.log('??')
  try{

    let sucursales_seleccionadas : any = []
    for(let sucursal of sucursales) if(sucursal.checked) sucursales_seleccionadas.push(sucursal)
      if(sucursales_seleccionadas.length===0){
        toast.error('Debes seleccionar al menos una sucursal')
        return 
      }
    // console.log(sucursales_seleccionadas)

      await dialog.open({
        accept: 'Deseas Actualizar la lista?',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro de la información?',
        // soundAccept: 'https://assets.stoumann.dk/audio/accept.mp3',
        // soundOpen: 'https://assets.stoumann.dk/audio/open.mp3',
        target: event.target,
        template: `
          <dl>
            <dt>Nombre</dt>
            <dd>`+director_comercial.nombres+` `+director_comercial.paterno+` `+director_comercial.materno+`</dd>
            <dt>Sucursales Asignadas</dt>
            <dd>`+sucursales_seleccionadas.map((suc:any)=>{return suc.sucursal}).join(', ')+`</dd>
          </dl>
        `
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        setSeEnvio(true)
      // console.log('lo que se envia es:', nuevo_usuario)
        let res_nuevo_usuario = await RequestService.create('director_comercial/actualizar_sucursales/'+director_comercial.uuid, { sucursales : sucursales_seleccionadas })

        if(res_nuevo_usuario){
          toast.success('La lista de Sucursales de Reporte se actualizó')
          setTimeout(()=>{
            handleClose()
          },0)
        }
        else{
          toast.error('Error al crear usuario en el servidor')
        }  
        
      }
    }
    catch(e:any){
      toast.error(e.response.data)
    }
     
}

  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Sucursales Asignadas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            // JSON.stringify(director_comercial)
          }

          {
            // JSON.stringify(sucursales)
          }

          <dl>
            <dt>Nombre</dt>
            <dd>{director_comercial.nombres+` `+director_comercial.paterno+` `+director_comercial.materno}</dd>
          </dl>

          <Row className="mt-3">
            {
              // JSON.stringify(sucursales)
            }

              <Form.Label>Responsable de las siguientes sucursales:</Form.Label>
              <div>
                  {
                    sucursales.map((sucursal:any,i:number)=>
                      <Form.Check
                        key={ Math.random().toString(36).substr(2, 9) }
                        inline
                        name="sucursales"
                        type="checkbox"
                        label={sucursal.sucursal}
                        checked={sucursales[i].checked}
                        onChange={(e)=>{ var ne = [...sucursales]; ne[i].checked = e.target.checked;  setSucursales(ne);}}
                        id={`sucu`+i} />

                      )
                  }

              </div>
          </Row>



        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" onClick={(e:any)=>{enviarFormulario(e)}} type="button">Ok</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}


export default ModalSucursalesDirectorComercial;